import { useState, useEffect, useCallback } from 'react';
import { getTokenFromCookie, validateToken } from '../services/authService';

export const useAuth = () => {
    const [authToken, setAuthToken] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authError, setAuthError] = useState(null);
    const [isAuthLoading, setIsAuthLoading] = useState(true);

    const initializeAuth = useCallback(async () => {
        setIsAuthLoading(true);
        setAuthError(null);
        try {
            const token = getTokenFromCookie();
            if (!token) {
                // No es un error, simplemente no hay sesión
                setIsAuthenticated(false);
                return;
            }
            setAuthToken(token);
            const phone = await validateToken(token); // Validamos pero no necesitamos el teléfono aquí
            setPhoneNumber(phone);
            setIsAuthenticated(true);
        } catch (error) {
            console.error('Authentication error:', error);
            setAuthError(error.message);
            setIsAuthenticated(false);
        } finally {
            setIsAuthLoading(false);
        }
    }, []);

    useEffect(() => {
        initializeAuth();
    }, [initializeAuth]);

    return { authToken, phoneNumber, isAuthenticated, authError, isAuthLoading };
};